// extracted by mini-css-extract-plugin
module.exports = {"button-style":"hollowButton_button-style__2gSn5"};